import { createContext } from 'react';
import type { PrivateUser } from './auth-types';

export interface AuthContextValue {
  user: PrivateUser | null;
  status: 'loading' | 'authenticated' | 'anonymous';
  refresh: () => Promise<void>;
  login: (input: { email: string; password: string }) => Promise<PrivateUser>;
  register: (input: {
    email: string;
    password: string;
    username: string;
    displayName: string;
  }) => Promise<PrivateUser>;
  logout: () => Promise<void>;
  setUser: (user: PrivateUser) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
